// extracted by mini-css-extract-plugin
export default {"root":"ConfigurableValuesPage_root__oZYp6","items":"ConfigurableValuesPage_items__J7RM-","header":"ConfigurableValuesPage_header__z3UzH"};